/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAtSign = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2c5.43 0 9.848 4.327 9.996 9.72L22 12v.5a3.5 3.5 0 0 1-5.98 2.47A5 5 0 1 1 15 8V7h2v5.5a1.5 1.5 0 0 0 2.993.145L20 12.5V12a8 8 0 1 0-3.82 6.823l.264-.17 1.112 1.662A9.96 9.96 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2zm0 7a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgAtSign as AtSign };
